<template>
  <div class="content">
    <div>
      <b-container>
        <transition name="scale" mode="out-in">
          <router-view></router-view>
        </transition>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Content',
}
</script>

<style lang="scss" scoped>
.content {
  grid-area: content;
  margin-top: 15px;
  margin-right: 15px;
  margin-left: 15px;
  height: calc(100% - 15px - 15px);
  padding-top: 20px;
  padding-bottom: 20px;
  overflow: hidden;
  border-radius: 30px;
  background-color: #ffffff;
  > div {
    height: 100%;
    overflow: auto;
  }
}
.scale {
  &-enter-active,&-leave-active {
    transition: all 0.5s ease;
  }
  &-enter-from,&-leave-to {
    opacity: 0;
    transform: scale(0.9);
  }
}
</style>